'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _YouTubeIcon = require('./YouTubeIcon');

var _YouTubeIcon2 = _interopRequireDefault(_YouTubeIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _YouTubeIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/YouTubeIcon/index.js
// module id = 703
// module chunks = 11